import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconLink2 = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--link-2")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M15,8 L18,8 C19.060866,8 20.0782816,8.42142736 20.8284271,9.17157288 C21.5785726,9.92171839 22,10.939134 22,12 C22,14.209139 20.209139,16 18,16 L15,16 C14.4477153,16 14,16.4477153 14,17 C14,17.5522847 14.4477153,18 15,18 L18,18 C21.3137085,18 24,15.3137085 24,12 C24,10.4087011 23.367859,8.88257758 22.2426407,7.75735931 C21.1174224,6.63214104 19.5912989,6 18,6 L15,6 C14.4477153,6 14,6.44771525 14,7 C14,7.55228475 14.4477153,8 15,8 Z M9,6 C9.55228475,6 10,6.44771525 10,7 C10,7.55228475 9.55228475,8 9,8 L9,8 L6,8 C3.790861,8 2,9.790861 2,12 C2,13.060866 2.42142736,14.0782816 3.17157288,14.8284271 C3.92171839,15.5785726 4.93913404,16 6,16 L6,16 L9,16 C9.55228475,16 10,16.4477153 10,17 C10,17.5522847 9.55228475,18 9,18 L9,18 L6,18 C4.40870106,18 2.88257758,17.367859 1.75735931,16.2426407 C0.632141042,15.1174224 0,13.5912989 0,12 C0,8.6862915 2.6862915,6 6,6 L6,6 Z M16,11 C16.5522847,11 17,11.4477153 17,12 C17,12.5522847 16.5522847,13 16,13 L16,13 L8,13 C7.44771525,13 7,12.5522847 7,12 C7,11.4477153 7.44771525,11 8,11 L8,11 Z" id="icon--centivo--link-2"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-375.000000, -749.000000)"/>
          <g id="Icon/link-2">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--link-2"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--link-2"/>
          </g>
      </g>
  </IconWrapper>
)
